import React from "react";
import { useTranslation } from "../../../i18n/LanguageContext";

const PROFILE_TRANSLATION_KEYS = {
   Organization: {
      label: "profile-organization-label",
      description: "signup-role-organization-description"
   },
   Donors: { label: "profile-donor-label", description: "signup-role-donor-description" },
   Expert: { label: "profile-expert-label", description: "signup-role-expert-description" }
};

const ProfileOption = ({ profile, selectedProfile, onSelect, image }) => {
   const { t } = useTranslation();
   const keys = PROFILE_TRANSLATION_KEYS[profile];
   const label = keys ? t(keys.label) : profile;
   const isSelected = selectedProfile === profile;

   return (
      <button
         type="button"
         role="radio"
         aria-checked={isSelected}
         onClick={() => onSelect(profile)}
         className={`kap-signup__option${isSelected ? " kap-signup__option--selected" : ""}`}
      >
         <img src={image} alt="" className="kap-signup__option-icon" />
         <span className="kap-signup__option-text">
            <span className="kap-signup__option-label">{label}</span>
            {keys && (
               <span className="kap-signup__option-description">{t(keys.description)}</span>
            )}
         </span>
         <span className="kap-signup__radio" />
      </button>
   );
};

export default ProfileOption;
